import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

@Injectable()
export class ConfigService {
    private http: HttpClient;
    private envJson: any;
    private validConfig: boolean;

    constructor(injector: Injector) {
        this.http = injector.get(HttpClient);
        this.validConfig = false;
    }

    load(): any {
        if (environment.jsonConfig) {
            const headers = new HttpHeaders({ 'Cache-Control': 'no-cache', 'Pramga': 'no-cache' });
            return this.http.get(environment.jsonConfig, { headers: headers })
                .toPromise()
                .then((result: any) => {
                    this.envJson = result;
                    this.validConfig = true;
                    return result;
                })
                .catch((error: any) => {
                    return error;
                });
        } else {
            this.validConfig = true;
        }
    }

    isValidConfig(): boolean {
        return this.validConfig;
    }

    getEnv(key: any): string {
        if (this.envJson) {
            return this.envJson[key] !== undefined ? this.envJson[key] : environment[key];
        } else {
            return environment[key];
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/config-service.ts